import { request } from '@/shared/api/request'
export const getRequestsAdjustment = () => {
	return request({ url: 'contract/labor/getRequestsAdjustmentData', method: 'GET' })
}
